/**
 * Client-side privacy plugin.
 * Restores privacy preferences from localStorage on hydration and applies to GA/HubSpot.
 */
export default defineNuxtPlugin(() => {
  const { restoreFromLocal } = usePrivacy()

  // Restore saved preferences if localStorage has user choices from previous session
  restoreFromLocal()
})
